module.exports = __webpack_public_path__ + "static/media/pensive_face_emoji.b813a8b0.png";